import { useMutation, useQuery } from '@tanstack/react-query';
import { useLanguage } from '../hooks';
import { useSnackbar } from 'notistack';
import { currentUserApi } from '../axios';
import { useOnboarding } from '../components/Onboarding/OnboardingContext';
import { paths } from '../utils/navigation';

export function useOnboardingQuery() {
  return useQuery({
    queryKey: ['onboarding'],
    queryFn: currentUserApi.getCurrentOnboarding,
  });
}

export function useResetOnboardingMutation() {
  const lang = useLanguage();
  const { enqueueSnackbar } = useSnackbar();
  const { resetProfileData, navigateWithParams } = useOnboarding();

  return useMutation({
    mutationFn: async () => {
      return await currentUserApi.resetOnboarding();
    },
    onSuccess: () => {
      resetProfileData();
      navigateWithParams(paths.onboarding.step.replace(':step', 'step1'), true);
    },
    onError: () => {
      enqueueSnackbar(lang.wizard.onboardingResetModal.error, { variant: 'error' });
    },
  });
}
